import { Button } from 'components/ui/Button'
import { useTranslation } from 'react-i18next'
import { NsKey } from 'enums/NsKey'
import { Sizes } from 'enums/sizes'
import { TrashIcon } from 'components/icons/Icons'

export interface PanelFooterProps {
  onClose: () => void
  onDelete?: () => void
  deleteLabel?: string
  deleteDisabled?: boolean
  isLoading: boolean
  onSubmit: () => void
  closeLabel: string
  submitDisabled?: boolean
  submitLabel: string
}

const PanelFooter: React.FC<PanelFooterProps> = ({
  onClose,
  onDelete,
  deleteLabel,
  deleteDisabled,
  onSubmit,
  submitLabel,
  submitDisabled,
  closeLabel,
  isLoading
}) => {
  const { t } = useTranslation(NsKey.Common)

  return (
    <div className="sticky bottom-0 flex p-4 bg-white">
      <div className="flex w-full gap-4 justify-between">
        <div className="flex items-center">
          {onDelete && (
            <Button color='slate' round onClick={onDelete} disabled={deleteDisabled}>
              <TrashIcon />
              {deleteLabel && t(deleteLabel)}
            </Button>
          )}
        </div>
        <div className="flex gap-4">
          <Button
            size={Sizes.lg}
            outline
            disabled={isLoading}
            onClick={onClose}
          >
            {t(closeLabel)}
          </Button>
          <Button
            color="secondary"
            type="submit"
            size={Sizes.lg}
            disabled={submitDisabled || isLoading}
            onClick={() => onSubmit()}
          >
            {t(submitLabel)}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PanelFooter
